import React, { Component } from 'react';
import { StateCombobox } from './StateCombobox';

export class SearchPanel extends Component {
  constructor(props) {
    super(props);
    this.searchParams = props.searchParams;
  }

  render() {
    const searchParams = this.props.searchParams;
    return (
      <form>
        <div className='px-md-3'>
          <div className='row justify-content-start'>
            <div className='col-md-2 px-md-1'>
              <StateCombobox selectedState={searchParams.authorityName} onChangeState={(e) => this.props.handleChangeProps({ authorityName: e }) } />
            </div>
            <div className='col-md-3 px-md-1'>
              <input type='text' placeholder='Request date (yyyy-mm-dd)'
                className='form-control'
                value={searchParams.requestDate}
                onChange={(e) => this.props.handleChangeProps({ requestDate: e.target.value })}  />
            </div>
            <div className='col-md-4 px-md-1'>
              <input type='text' placeholder='Request Identity'
                className='form-control'
                value={searchParams.requestId}
                onChange={(e) => this.props.handleChangeProps({ requestId: e.target.value })} />
            </div>
          </div>
          <div className='row justify-content-start'>
            <div className='col-md-3 px-md-1'>
              <input type='text' placeholder='Patient Dob (yyyy-mm-dd)'
                className='form-control'
                value={searchParams.patientDob}
                onChange={(e) => this.props.handleChangeProps({ patientDob: e.target.value })} />
            </div>
            <div className='col-md-3 px-md-1'>
              <input type='text'
                placeholder='Patient LastName'
                value={searchParams.patientLastName}
                className='form-control'
                onChange={(e) => this.props.handleChangeProps({ patientLastName: e.target.value })} />
            </div>
            <div className='col-md-3 px-md-1'>
              <input type='text'
                placeholder='Patient FirstName'
                className='form-control'
                value={searchParams.patientFirstName}
                onChange={(e) => this.props.handleChangeProps({ patientFirstName: e.target.value })} />
            </div>
          </div>
        </div>
      </form>
    );
  }
}